import React, { ReactNode } from 'react';
import { Modal, Form, Col, Container, Row } from 'react-bootstrap';
import { Button } from "./Button";
import { HeaderText } from "./HeaderText";

interface ConfirmModalProps {
    title:        ReactNode;
    message:      ReactNode;
    cancelText?:  ReactNode;
    confirmText?: ReactNode;
    show?:        boolean;
    setShow:      (show : boolean) => void;
    onConfirm:    () => void;
    /** Set false when this confirm opens over another modal to avoid stacked backdrops. */
    backdrop?:    boolean | 'static';
}

export function ConfirmModal( { show, setShow, onConfirm, title, message, cancelText = "Cancel", confirmText = "Confirm", backdrop = true }: ConfirmModalProps ) {
    function submit( e: React.FormEvent ) {
        e.preventDefault();
        onConfirm();
        setShow( false );
    }

    if( !show ) {
        return <></>;
    }

    return <Modal show={!!show} centered backdrop={backdrop} enforceFocus={false} onEscapeKeyDown={ () => setShow( false ) }>
        <Modal.Header>
            <HeaderText>{title}</HeaderText>
        </Modal.Header>
        <Modal.Body className="pt-0 mt-0">
            <Form onSubmit={submit}>
                <Container className="g-0 py-4">
                    <Row>
                        <Col className="text-secondary">
                            {message}
                        </Col>
                    </Row>
                </Container>
                <div className="d-flex justify-content-end gap-2">
                    <Button
                        type="button"
                        className="w-100"
                        onClick={ () => setShow( false )}>
                        {cancelText}
                    </Button>
                    <Button
                        type="submit"
                        className="w-100 btn-main">
                        {confirmText}
                    </Button>
                </div>
            </Form>
        </Modal.Body>
    </Modal>;
}